import { FileTextOutlined } from '@ant-design/icons';
import UserInfo from 'components/ui/user-info';
import { ClaimResponseDto } from 'libs/pinnacle-sdk';
import CustomBadge from '../custom-badge';
import { useTranslation } from 'react-i18next';

interface ClaimHeaderProps {
  claim: ClaimResponseDto;
  onStatusClick?: () => void;
}

const ClaimHeader = ({ claim, onStatusClick }: ClaimHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between py-4">
      {/* Left side */}
      <div>
        <div className="flex items-center gap-2">
          <span className="text-[#5e6b7c] text-sm">
            {t('claim.masterClaimId')}:
          </span>
          <span className="text-[#1d67b6] font-medium">{claim.claimId}</span>
        </div>
        <h1 className="text-2xl font-semibold text-[#010d1d] mt-1">
          {claim.insured?.name || '-'}
        </h1>
      </div>

      {/* Right side */}
      <div className="flex flex-col items-end gap-4">
        <div className="flex gap-4 items-start">
          <button className="flex items-center gap-2 px-6 py-2 shadow-md bg-[#1d67b6] text-white rounded-lg hover:bg-[#1d67b6]/90 transition-colors">
            <FileTextOutlined />
            <span>{t('claim.documents')}</span>
          </button>
          <div className="flex flex-col items-end">
            <div>{t('claim.assignedHandler')}:</div>
            <UserInfo name={claim.claimsHandlerUser?.name || '-'} />
          </div>
        </div>
        <div className="flex items-center gap-2">
          {t('claim.masterClaimStatus')}:
          <CustomBadge
            label={claim.status}
            onClick={onStatusClick}
            backgroundColor="bg-blue-100"
            textColor="text-blue-600"
          />
        </div>
      </div>
    </div>
  );
};

export default ClaimHeader;
